import { filterStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListFilter";
import { tableStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListTable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

tableStyles.orderNumberHeader = {
    css: css`
        span {
            color: ${getColor("text.main")};
        }
    `,
};
tableStyles.orderDateHeader = {
    css: css`
        span {
            color: ${getColor("text.main")};
        }
    `,
};
tableStyles.shipToLabelHeader = {
    css: css`
        span {
            color: ${getColor("text.main")};
        }
    `,
};
tableStyles.approverReasonHeader = {
    css: css`
        span {
            color: ${getColor("text.main")};
        }
    `,
};
tableStyles.totalHeader = {
    css: css`
        span {
            color: ${getColor("text.main")};
        }
    `,
};
tableStyles.orderNumberCell = {
    css: css`
        a {
            &:hover {
                text-decoration: underline;
            }
        }
    `,
};
tableStyles.dataTableHead = {
    css: css`
        th {
            white-space: nowrap;
            button {
                justify-content: center;
            }
        }
    `,
};
